import { isDevEnvironment } from '@top/shared/src/configs'
import { useSearchParams } from '@top/shared/src/hooks/useSearchParams'

export function useIsSceneModulesEnabled() {
  const params = useSearchParams()
  const isSceneModulesEnabled = params.get('sceneModules')

  return isDevEnvironment() && !!isSceneModulesEnabled && parseInt(isSceneModulesEnabled) === 1
}
